export const CognitoConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID || '',
      loginWith: {
        email: true,
        username: true,
      },
      signUpVerificationMethod: 'code',
      passwordProtectionSettings: {
        passwordPolicyMinLength: 12,
        passwordPolicyCharacters: ['lowercase', 'uppercase', 'numbers', 'symbols'],
      },
      mfaConfiguration: 'REQUIRED',
      mfaTypes: ['TOTP'],
    },
  },
} as const;

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';